import { type FC } from 'react';

import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';

import { Box } from '@craft/ui/components/structural';

export const NotClearedBadge: FC = () => (
  <Box alignItems='center' display='flex' justifyContent='center'>
    <WarningAmberOutlined color='warning' />
  </Box>
);
